/**
 * Texte für die "WARUM ALPHA?"-Sektion auf der Landing-Page (home.ts).
 *
 * Der Wipe-Absatz (ALPHA_WHY_MEANING_ITEMS[1]) ist Teil der öffentlichen
 * Wipe-Zusage (siehe CLAUDE.md, Kapitel "Wipe-/Reset-Garantie") — NICHT
 * umformulieren, ohne CLAUDE.md/AGB/Landingpage synchron zu halten
 * (NT-CLAUDEMD-WIPE-01 Regel 8).
 *
 * Literale UTF-8-Umlaute/ß (kein HTML-Entity-Encoding) — Konvention für
 * Dateien unter src/data/, siehe eu-countries.ts.
 */

export const ALPHA_WHY_TITLE = 'WARUM ALPHA?';

export const ALPHA_WHY_INTRO_PARAGRAPHS: readonly string[] = [
  'Weil das Wort inzwischen meistens heißt „fertig, aber wir wollen uns noch rausreden können". Bei uns heißt es das Gegenteil.',
  'Die ehrliche Fassung: Ich wollte ein Spiel bauen. Ich hab\'s Freunden gezeigt. Zurück kam: „Hol doch mehr Spieler dazu." Also wurde aus einem Projekt ein Laden mit Kundschaft. Ihr seid die Kundschaft.',
  'Es wird gebaut, während ihr spielt. Systeme kommen dazu, Zahlen werden angefasst, Fehler findet ihr schneller als ich. Kein Countdown, kein Roadmap-Theater.',
];

export const ALPHA_WHY_TRIGGER_LABEL = 'WAS DAS KONKRET HEISST';

export const ALPHA_WHY_MESSAGE_HEADING = 'EINE NACHRICHT VON ARIDARA STUDIOS';

export const ALPHA_WHY_MESSAGE_PARAGRAPHS: readonly string[] = [
  'Ohne Pointe: Nighttrade läuft, aber es ist nicht fertig. Wer jetzt dabei ist, spielt keine Demo eines fertigen Spiels, sondern die frühe Version eines wachsenden. Drei Dinge solltet ihr dazu wissen.',
];

export const ALPHA_WHY_MEANING_ITEMS: readonly string[] = [
  'Der Zugang ist begrenzt, weil die Infrastruktur mitwachsen muss.',
  'Ein Zurücksetzen des Spielstands ist nicht vorgesehen und wird von mir aktiv vermieden. Vollständig ausschließen kann ich es für die Alpha nicht. Sollte es je notwendig werden, betrifft es ausschließlich den Spielfortschritt — Auszeichnungen, Titel und Unterstützerstatus bleiben in jedem Fall erhalten.',
  'Rückmeldungen aus der Alpha ändern das Spiel tatsächlich. Es gibt keine Instanz zwischen euch und der Entwicklung.',
];

export const ALPHA_WHY_SIGNATURE = '— Aridara Studios';
